import * as React from "react";
import {Button, Header, Icon, Modal} from "semantic-ui-react";
import {Queue, QueuedEvent} from "../../../../../../generated/index";
import {LogView} from "../../../logView/LogView";
import TestSuppressionScriptModalTabView from "./TestSuppressionScriptModalTabView";
import {Splitter} from "../../../../../util/table-splitter-ui/src/components/Splitters/Splitter";
import ReactTable from "react-table";
import {QueuedEventDiffModal} from "../../modal/QueuedEventDiffModal";
import {SplitterHorizontal} from "../../../../../util/table-splitter-ui/src/components/Splitters/SplitterHorizontal";

export interface TestSuppressionScriptModalProps {
    isOpen: boolean
    onClose: (success) => void
    queue: Queue
    history: any
}


export function TestSuppressionScriptModal(props: React.PropsWithChildren<TestSuppressionScriptModalProps>) {

    const [activeIndex, setActiveIndex] = React.useState(0)
    const [selected, setSelected] = React.useState<QueuedEvent[]>([])
    const [before, setBefore] = React.useState<QueuedEvent>(null)
    const [after, setAfter] = React.useState<QueuedEvent>(null)
    const [showDiff, setShowDiff] = React.useState(false)

    const [xRequestId, setXRequestId] = React.useState(null)
    const [output, setOutput] = React.useState<QueuedEvent[]>([])

    function handleClose(success: any) {
        props.onClose(success)
    }

    function handleClick(e: any, titleProps: any) {
        const {index} = titleProps
        const newIndex = activeIndex === index ? -1 : index
        setActiveIndex(newIndex)
    }

    function changed(afterEvent: QueuedEvent) {
        let beforeEvent = selected.find(s => s._id === afterEvent._id)
        let hasChanged = JSON.stringify(beforeEvent) !== JSON.stringify(afterEvent)
        if (hasChanged) {
            return <a style={{color: "blue", fontSize: "large"}}> <Icon name={"radio"} color={"blue"}/> change detected!</a>
        }
        return <a style={{fontSize: "large"}}> <Icon name={"radio"}/>No change!</a>
    }

    function renderResultTable() {
        if (output && output.length > 0) {
            const columns = [
                {
                    id: 'Changed',
                    Header: 'changed',
                    width: 200,
                    accessor: (d: any) => changed(d),
                    sortField: 'CHANGE'
                },
                {
                    id: 'suppressed',
                    Header: 'suppressed',
                    width: 150,
                    accessor: (d: any) => drawSuppression(d),
                    sortField: 'SUPPRESSED'
                },
                {
                    id: 'queueType',
                    Header: 'queueType',
                    width: 150,
                    accessor: (d: any) => d.queueType,
                    sortField: 'QUEUE_TYPE'
                }, {
                    id: 'eventType',
                    Header: 'eventType',
                    width: 200,
                    accessor: (d: any) => d.eventType,
                    sortField: 'EVENT_TYPE'
                },
                {
                    id: 'orderId',
                    Header: 'Order ID',
                    width: 100,
                    accessor: (d: QueuedEvent) => d.transportOrderEvent?.transportOrder?._id ?? d.positionEvent?.transportOrderId ?? d.etaEvent?.transportOrder?._id,
                    Cell: (d: any) => {
                        return <span>{d.value}</span>
                    }
                },
                {
                    id: 'changeType',
                    Header: 'Change Type',
                    width: 150,
                    accessor: (d: QueuedEvent) => d.transportOrderEvent?.change?.type ?? (d.etaEvent?.nextStops && d.etaEvent?.nextStops[0]?.city),
                    Cell: (d: any) => {
                        return <span>{d.value}</span>
                    }
                },
            ]

            return <ReactTable
                data={output}
                columns={columns}
                showPagination={false}
                pageSize={output.length}
                className="-striped -highlight"
                getTdProps={(state, rowInfo) => {
                    return {
                        onClick: () => {
                            setBefore(selected.find(s => s._id === rowInfo.row._original._id))
                            setAfter(rowInfo.row._original)
                            setShowDiff(true)
                        }
                    };
                }}
            />
        } else {
            return <h4>No Output, yet!</h4>
        }
    }

    function drawSuppression(event) {
        if (event) {
            let suppressed = event.suppressed
            if (suppressed == true) {
                return <a style={{color: "green", fontSize: "large"}}> <Icon name={"check"} color={"green"}/>Suppressed!</a>
            } else {
                return <a style={{color: "red", fontSize: "large"}}> <Icon name={"x"} color={"red"}/> NOT
                    suppressed!</a>
            }
        }
        return <a style={{color: "black", fontSize: "large"}}> unknown</a>
    }

    return <Modal
        open={props.isOpen}
        onClose={handleClose}
        dimmer="blurring"
        size='fullscreen'>
        <Header icon='browser' content='Test Suppression Script'/>
        <Modal.Content>
            <Splitter
                name={"SuppressionScriptTestModalSplitter"}
                left={
                    <TestSuppressionScriptModalTabView
                        queue={props.queue}
                        history={props.history}
                        updateResponse={(xRequestId, output) => {
                            setXRequestId(xRequestId)
                            setOutput(output)
                        }}
                    />
                }
                right={
                    <SplitterHorizontal
                        name={"TestSuppressionScriptOutputSplitter"}
                        top={renderResultTable()}
                        bottom={
                            <LogView
                                query={xRequestId}
                                origin={"suppressionScriptModal"}
                                initialTimespan={null}
                                responseLogs={null}
                            />
                        }

                    />
                }
            />
            <Button onClick={() => handleClose(false)}>Close</Button>

            <QueuedEventDiffModal
                isOpen={showDiff}
                onClose={() => setShowDiff(false)}
                before={before}
                after={after}
            />
        </Modal.Content>

    </Modal>

}

